define('OutSystems/ClientRuntime/modules/Database/WebSQL/WebSQLDatabase',["require", "exports", "tslib", "../../../Exceptions", "../../../Logger", "../../../NativeHelper", "../Common/Database", "./WebSQLTransaction", "./WebSQLTransactionMode"], function (require, exports, tslib_1, Exceptions_1, Logger, NativeHelper, Database_1, WebSQLTransaction_1, WebSQLTransactionMode_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var COULD_NOT_OPEN_DATABASE_MSG = "Could not open database";
    var CANARY_QUERY_ERROR = "Failed to execute canary query (probably due to zombie transaction)";
    var WebSQLDatabase = (function (_super) {
        tslib_1.__extends(WebSQLDatabase, _super);
        function WebSQLDatabase(databaseName, databaseImplementation) {
            var _this = _super.call(this, databaseName) || this;
            _this.databaseImplementation = databaseImplementation;
            return _this;
        }
        WebSQLDatabase.open = function (databaseName) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var _a, _b;
                return tslib_1.__generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!!this.cache[databaseName]) return [3, 2];
                            _a = this.cache;
                            _b = databaseName;
                            return [4, WebSQLDatabase.innerOpen(databaseName)];
                        case 1:
                            _a[_b] = _c.sent();
                            _c.label = 2;
                        case 2: return [2, this.cache[databaseName]];
                    }
                });
            });
        };
        WebSQLDatabase.innerOpen = function (databaseName) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    if (typeof window === "undefined") {
                        throw new Exceptions_1.Exceptions.SystemException("Database is only available in the browser/web view");
                    }
                    if (NativeHelper.isRunningOnNative()) {
                        return [2, WebSQLDatabase.openPluginDatabase(databaseName)];
                    }
                    else if (WebSQLDatabase.isWebSQLSupported()) {
                        return [2, WebSQLDatabase.openWebSQLDatabase(databaseName)];
                    }
                    else {
                        WebSQLDatabase.throwDatabaseRequiredError();
                    }
                    return [2];
                });
            });
        };
        WebSQLDatabase.openPluginDatabase = function (databaseName) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var w;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, NativeHelper.ensureNativeReady()];
                        case 1:
                            _a.sent();
                            w = window;
                            if (w.sqlitePlugin) {
                                Logger.trace(WebSQLDatabase, "Opening database '".concat(databaseName, "'"));
                                return [2, new Promise(function (resolve, reject) {
                                        try {
                                            w.sqlitePlugin.openDatabase({ name: databaseName, location: "default" }, function (database) {
                                                if (database) {
                                                    Logger.trace(WebSQLDatabase, "Database '".concat(databaseName, "' opened successfully"));
                                                    resolve(new WebSQLDatabase(databaseName, database));
                                                }
                                                else {
                                                    Logger.trace(WebSQLDatabase, "Error opening database '".concat(databaseName, "'"));
                                                    reject(new Exceptions_1.Exceptions.OpenDatabaseException("".concat(COULD_NOT_OPEN_DATABASE_MSG, " '").concat(databaseName, "'")));
                                                }
                                            }, function (sqlError) {
                                                Logger.trace(WebSQLDatabase, "Error opening database '".concat(databaseName, "' ") + sqlError.message);
                                                reject(new Exceptions_1.Exceptions.OpenDatabaseException("".concat(COULD_NOT_OPEN_DATABASE_MSG, " '").concat(databaseName, "': ").concat(sqlError.message.toString())));
                                            });
                                        }
                                        catch (error) {
                                            reject(new Exceptions_1.Exceptions.OpenDatabaseException("".concat(COULD_NOT_OPEN_DATABASE_MSG, " '").concat(databaseName, "': ").concat(error.message.toString())));
                                        }
                                    })];
                            }
                            else {
                                throw new Exceptions_1.Exceptions.OpenDatabaseException("No database driver available");
                            }
                            return [2];
                    }
                });
            });
        };
        WebSQLDatabase.openWebSQLDatabase = function (databaseName) {
            var w = window;
            var database;
            try {
                Logger.trace(WebSQLDatabase, "Opening database '".concat(databaseName, "'"));
                database = w.openDatabase(databaseName, "1.0", databaseName, 5 * 1024 * 1024);
            }
            catch (error) {
                throw new Exceptions_1.Exceptions.OpenDatabaseException("".concat(COULD_NOT_OPEN_DATABASE_MSG, " '").concat(databaseName, "': ").concat(error.message.toString()));
            }
            if (database) {
                Logger.trace(WebSQLDatabase, "Database '".concat(databaseName, "' opened successfully"));
                return new WebSQLDatabase(databaseName, database);
            }
            else {
                Logger.trace(WebSQLDatabase, "Error opening database '".concat(databaseName, "'"));
                throw new Exceptions_1.Exceptions.OpenDatabaseException("".concat(COULD_NOT_OPEN_DATABASE_MSG, " '").concat(databaseName, "'"));
            }
        };
        WebSQLDatabase.isWebSQLSupported = function () {
            var w = window;
            return !!w.openDatabase;
        };
        WebSQLDatabase.throwDatabaseRequiredError = function () {
            var w = window;
            var isChrome = !!w.chrome;
            var errorMessage = "Your app requires native access to a Local Storage database that is not available in your browser.\n\nPlease test your app in your mobile device" +
                (isChrome ? "" : ", or use Google Chrome web browser") +
                ".";
            alert(errorMessage);
            throw new Exceptions_1.Exceptions.SystemException(errorMessage);
        };
        WebSQLDatabase.prototype.testConnection = function () {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var maxCanaryQueries, failCount;
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            maxCanaryQueries = 5;
                            failCount = 0;
                            this.trace("Starting to test on database connections. Performing #".concat(maxCanaryQueries, " test queries."));
                            return [4, Promise.all(Array.apply(null, new Array(maxCanaryQueries)).map(function () {
                                    return new Promise(function (resolve) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                        var error_1;
                                        return tslib_1.__generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    _a.trys.push([0, 2, 3, 4]);
                                                    return [4, this.executeTransaction(function (transaction) {
                                                            return transaction.executeQuery(function (transaction) {
                                                                return new Promise(function (resolve, reject) {
                                                                    transaction.executeSql("SELECT 1", null, function () { return resolve(); }, function (_, error) {
                                                                        reject(new Error(error.message.toString()));
                                                                        return false;
                                                                    });
                                                                });
                                                            });
                                                        })];
                                                case 1:
                                                    _a.sent();
                                                    return [3, 4];
                                                case 2:
                                                    error_1 = _a.sent();
                                                    failCount++;
                                                    Logger.error("WebSQLDatabase", CANARY_QUERY_ERROR, error_1);
                                                    return [3, 4];
                                                case 3:
                                                    resolve();
                                                    return [7];
                                                case 4: return [2];
                                            }
                                        });
                                    }); });
                                }))];
                        case 1:
                            _a.sent();
                            this.trace("Finished tests on database connections. #".concat(maxCanaryQueries - failCount, " out of #").concat(maxCanaryQueries, " successful queries."));
                            return [2];
                    }
                });
            });
        };
        WebSQLDatabase.prototype.close = function () {
            this.databaseImplementation = null;
            delete WebSQLDatabase.cache[this.name];
            return Promise.resolve();
        };
        WebSQLDatabase.prototype.executeQuery = function (body, allowTraces) {
            if (allowTraces === void 0) { allowTraces = true; }
            return this.executeReadTransaction(function (abstractTransaction) { return abstractTransaction.executeQuery(body); }, allowTraces);
        };
        WebSQLDatabase.prototype.executeTransaction = function (body, allowTraces, affectedTables) {
            if (allowTraces === void 0) { allowTraces = true; }
            return this.innerExecuteTransaction(body, WebSQLTransactionMode_1.default.Write, allowTraces, affectedTables);
        };
        WebSQLDatabase.prototype.executeReadTransaction = function (body, allowTraces, affectedTables) {
            if (allowTraces === void 0) { allowTraces = true; }
            return this.innerExecuteTransaction(body, WebSQLTransactionMode_1.default.Read, allowTraces, affectedTables);
        };
        WebSQLDatabase.prototype.executeUpgradeTransaction = function (body, allowTraces) {
            if (allowTraces === void 0) { allowTraces = true; }
            return this.innerExecuteTransaction(body, WebSQLTransactionMode_1.default.Upgrade, allowTraces);
        };
        WebSQLDatabase.prototype.innerExecuteTransaction = function (body, mode, allowTraces, _) {
            var _this = this;
            if (allowTraces === void 0) { allowTraces = true; }
            return new Promise(function (resolve, reject) {
                var tx;
                var result;
                var caughtError;
                _this.innerExecuteTransactionInMode(mode === WebSQLTransactionMode_1.default.Read, function (sqlTx) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var error_2;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                tx = new WebSQLTransaction_1.default(allowTraces, sqlTx, mode);
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4, body(tx)];
                            case 2:
                                result = _a.sent();
                                return [3, 4];
                            case 3:
                                error_2 = _a.sent();
                                caughtError = error_2;
                                sqlTx.executeSql("ABORT_TRANSACTION", null, function () { }, function () { return true; });
                                return [3, 4];
                            case 4: return [2];
                        }
                    });
                }); }, function (error) {
                    var realError = caughtError !== null && caughtError !== void 0 ? caughtError : new Error(error.message.toString());
                    _this.trace("Aborting transaction ".concat(tx === null || tx === void 0 ? void 0 : tx.transactionId, ": ").concat(realError), allowTraces);
                    reject(realError);
                }, function () {
                    _this.trace("Committing transaction ".concat(tx === null || tx === void 0 ? void 0 : tx.transactionId), allowTraces);
                    resolve(result);
                });
            });
        };
        WebSQLDatabase.prototype.innerExecuteTransactionInMode = function (isReadOnly, callback, errorCallback, successCallback) {
            if (isReadOnly) {
                this.databaseImplementation.readTransaction(callback, errorCallback, successCallback);
            }
            else {
                this.databaseImplementation.transaction(callback, errorCallback, successCallback);
            }
        };
        WebSQLDatabase.prototype.trace = function (msg, allowTraces) {
            if (allowTraces === void 0) { allowTraces = true; }
            if (allowTraces) {
                Logger.trace(this, msg);
            }
        };
        WebSQLDatabase.cache = {};
        return WebSQLDatabase;
    }(Database_1.default));
    exports.default = WebSQLDatabase;
});
//# sourceMappingURL=WebSQLDatabase.js.map;
